// LinkedIn pop-up window
let linkedinShareBtns = document.querySelectorAll('.linkedin-share')
if (!!linkedinShareBtns.length) {
	linkedinShareBtns.forEach(function(btn){
		btn.addEventListener('click', function(e) {
			e.preventDefault()
	
			let fbpopup = window.open('https://www.linkedin.com/feed/?shareActive=true&text=' + window.location.href, 'pop', 'width=600, height=600, scrollbars=no');
			return false;
		})
	})
}